import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EventCardComponent } from '../event-card/event-card.component';
import { DatePipe, NgClass, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';


import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
    selector: 'app-event-card-inverted',
    imports: [
        DatePipe,
        YoutubeComponent,
        EventDatePipe,
        RouterLink,
        NgClass,
        NgOptimizedImage,
        UrlRewritePipe,
        IconComponent,
    ],
    templateUrl: './event-card-inverted.component.html',
    styleUrl: './event-card-inverted.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventCardInvertedComponent extends EventCardComponent {
  hideImage = input<boolean>(false);
}
